import { WidgetType } from 'shared/widgets/utils';

import { createNewSubmitPageTitle } from './create';
import { manifestLocales } from './manifest.locales';
import SubmitPageTitleEn from './resources/en/submitPageTitle.svg';
import SubmitPageTitleHe from './resources/he/submitPageTitle.svg';
import { ManifestType } from '@/types/ManifestType';

export const Manifest: ManifestType = {
  name: WidgetType.SubmitPageTitle,
  previewGroups: [
    {
      id: 'SubmitPageTitle',
      divider: false,
      previews: [
        {
          name: 'SubmitPageTitle',
          previewImage: {
            paths: {
              en: SubmitPageTitleEn,
              he: SubmitPageTitleHe
            },
            alt: { ...manifestLocales.submitPageTitle.previewImageAlt },
            size: {
              width: 285,
              height: 44
            }
          },
          initializeProps: () => createNewSubmitPageTitle(),
          dimensions: {
            width: 1180,
            height: 'auto'
          }
        }
      ]
    }
  ],
  additionalData: {
    constraints: {
      minHeight: 48,
      minWidth: 1180
    }
  }
};
